import { render } from "./TagsContent.vue?vue&type=template&id=c98660fe"
import script from "./TagsContent.vue?vue&type=script&lang=js"
export * from "./TagsContent.vue?vue&type=script&lang=js"

import "./TagsContent.vue?vue&type=style&index=0&id=c98660fe&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__